module.exports = __webpack_public_path__ + "img/50ef2a1c159930061adad6d3a23aabf.7f4af2a4.png";